import React from "react";
import Header from "../Components/Header";

const Appointment=()=>{
    return(
        <>
         <Header
         smallHeading="Appointment"
  bigHeading="TRANSFORM YOURSELF"/>
        </>
    )
}

export default Appointment;